// extracted by mini-css-extract-plugin
export default {"container":"ImagePage_container__jrG-m"};